import { Suspense } from "react";
import { Box, Image, Tooltip } from "@chakra-ui/react";
import { useParams } from "react-router-dom";

import { Button } from "components/Button";
import { ErrorBoundary } from "components/ErrorBoundary";
import { Spinner } from "components/Spinner";
import { DangerousInnerHtml } from "components/DangerousInnerHtml";

import { useGetLoginSsoForm } from "../../infrastructure/useGetLoginSsoForm";

import logoLoginGov from "assets/logo_login_gov.png";

const SsoLoginButtonThrowable = () => {
  const { appointmentId } = useParams<{
    appointmentId: string;
  }>();
  const { data: html } = useGetLoginSsoForm(appointmentId);

  const handleOnClick = () => {
    // @ts-ignore
    const form = document
      .getElementById("sso-form")
      .getElementsByTagName("form")[0];
    form && form.submit();
  };

  return (
    <>
      {html && (
        <Box id="sso-form" visibility="hidden" h={0}>
          <DangerousInnerHtml html={html} />
        </Box>
      )}
      <Tooltip label={loginGovBtnDescription}>
        <Button
          minW="250px"
          onClick={handleOnClick}
          id="login-with-sso-btn"
          variant="outline"
        >
          <Image
            alt={"logoDescription"}
            w="auto"
            maxH="70px"
            maxW="120px"
            src={logoLoginGov}
          />
        </Button>
      </Tooltip>
    </>
  );
};

const loginGovBtnDescription = (
  <>
    Po wybraniu tej opcji nastąpi przekierowanie na stronę login.gov.pl, gdzie
    należy wybrać metodę autoryzacji, np. Profil Zaufany.
    <br />
    Użyte podczas logowania przez SSO dane osobowe będą przetwarzane w systemie
    w celu realizacji usługi.
  </>
);

const SsoLoginButton = () => {
  return (
    <Suspense fallback={<Spinner size="lg" mt={2} mx={4} />}>
      <ErrorBoundary fallback={() => <></>}>
        <SsoLoginButtonThrowable />
      </ErrorBoundary>
    </Suspense>
  );
};

export { SsoLoginButton };
